<tr>
  <td colspan="8">
    <span class="p-panel-header multi-choice-title"><i class="fa-solid {{icon}} fa-2x"></i> {{title}} </span>
    <span *ngFor="let value of valuesList;">
                                          {{value.lovValues}}
                                        </span>
  </td>
</tr>
